var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4173 1.16602L2.33398 6.99935V9.33268H24.5007V6.99935M18.6673 11.666V19.8327H22.1673V11.666M2.33398 25.666H24.5007V22.166H2.33398M11.6673 11.666V19.8327H15.1673V11.666M4.66732 11.666V19.8327H8.16732V11.666H4.66732Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIa);
export default __webpack_public_path__ + "static/media/homeIA.48a898c01a7f08528ca2d8ad88399674.svg";
export { ForwardRef as ReactComponent };